import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface ContactInfo {
  address: string;
  phone: string;
  email: string;
}

interface SocialMedia {
  facebook: string;
  instagram: string;
  twitter: string;
  tiktok: string;
}

interface HoursOfOperation {
  monday: string;
  tuesday: string;
  wednesday: string;
  thursday: string;
  friday: string;
  saturday: string;
  sunday: string;
}

interface Branding {
  logo_url: string;
  favicon_url: string;
}

export const useSiteSettings = () => {
  const [branding, setBranding] = useState<Branding>({
    logo_url: '',
    favicon_url: ''
  });

  const [contactInfo, setContactInfo] = useState<ContactInfo>({
    address: '123 Main Street, Albany, NY 12207',
    phone: '(518) 555-0123',
    email: 'hello@capitaldistrictsocial.com'
  });

  const [socialMedia, setSocialMedia] = useState<SocialMedia>({
    facebook: '',
    instagram: '',
    twitter: '',
    tiktok: ''
  });

  const [hours, setHours] = useState<HoursOfOperation>({
    monday: '3 PM – 12 AM',
    tuesday: '11 AM – 12 AM',
    wednesday: '11 AM – 12 AM',
    thursday: '11 AM – 2 AM',
    friday: '11 AM – 2 AM',
    saturday: '11 AM – 2 AM',
    sunday: '3 PM – 12 AM'
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const { data, error } = await supabase
        .from('site_settings')
        .select('*');

      if (error) throw error;

      data?.forEach(setting => {
        if (setting.setting_key === 'branding') {
          setBranding(setting.setting_value as unknown as Branding);
        } else if (setting.setting_key === 'contact_info') {
          setContactInfo(setting.setting_value as unknown as ContactInfo);
        } else if (setting.setting_key === 'social_media') {
          setSocialMedia(setting.setting_value as unknown as SocialMedia);
        } else if (setting.setting_key === 'hours_of_operation') {
          setHours(setting.setting_value as unknown as HoursOfOperation);
        }
      });
    } catch (error) {
      console.error('Error fetching site settings:', error);
    } finally {
      setLoading(false);
    }
  };

  return { branding, contactInfo, socialMedia, hours, loading };
};
